import ImagePlaceholder from "@/components/base/ImagePlaceholder";

const solutions = [
  "Pose en rénovation sur fenêtre existante sans travaux de maçonnerie",
  "Installation neuve sur menuiserie avec coffre intégré ou bloc-baie",
  "Remplacement complet d'un volet ancien par un modèle neuf",
  "Adaptation de la taille et du coffre à toutes les configurations de baie",
  "Pose en tunnel, en façade ou sous linteau selon la construction",
  "Finition soignée avec calfeutrage et joints pour l'étanchéité",
];

export default function Solutions() {
  return (
    <section className="bg-brand-light py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div>
            <h2 className="text-brand-blue text-2xl md:text-3xl font-extrabold mb-5">
              Volet neuf ou rénovation : nos solutions
            </h2>
            <p className="text-brand-text text-base leading-relaxed mb-4">
              Vous avez déjà une fenêtre avec un ancien volet roulant ? Nous pouvons remplacer l&apos;ensemble — coffre, tablier et mécanisme — sans toucher à la maçonnerie. C&apos;est ce qu&apos;on appelle la pose en rénovation : rapide, propre et sans dégâts. Le nouveau volet s&apos;adapte à votre cadre existant et vous offre immédiatement les performances d&apos;un modèle récent.
            </p>
            <p className="text-brand-text text-base leading-relaxed mb-6">
              Pour une construction neuve ou une extension, nous proposons des solutions en bloc-baie ou avec coffre intégré au linteau. Ces options offrent une esthétique épurée et une parfaite harmonie avec votre façade. Nous vous accompagnons dans le choix des matériaux, des couleurs et des options de motorisation pour un résultat durable et élégant.
            </p>
            <div className="space-y-3">
              {solutions.map((s) => (
                <div key={s} className="flex items-start gap-3">
                  <div className="w-6 h-6 flex items-center justify-center shrink-0 mt-0.5">
                    <i className="ri-check-line text-brand-cyan text-lg"></i>
                  </div>
                  <p className="text-brand-text text-sm leading-relaxed">{s}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="relative rounded-xl overflow-hidden border border-brand-border">
            <ImagePlaceholder
              src="https://readdy.ai/api/search-image?query=Modern%20French%20house%20facade%20with%20newly%20installed%20white%20roller%20shutters%20in%20different%20configurations%20including%20renovation%20and%20new%20construction%20clean%20professional%20real%20estate%20photography%20warm%20daylight%20Alsace%20region%20neutral%20tones&width=700&height=520&seq=pose-solutions&orientation=landscape"
              alt="Maison avec volets roulants neufs installés à Strasbourg"
              className="w-full h-[340px] md:h-[420px]"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}